import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { QuizQuestionQuizQuestionsBridge } from './bridges/quiz-question_quiz-questions.bridge';
import { QUIZ_QUESTIONS_FEATURE_KEY } from './keys';
import { quizQuestionsReducer } from './reducers/quiz-questions.reducer';
import { QuizQuestionsEffects } from './effects/quiz-questions.effects';

export function provideQuizQuestionsStore(): EnvironmentProviders[] {
    return [provideState(QUIZ_QUESTIONS_FEATURE_KEY, quizQuestionsReducer), provideEffects(QuizQuestionsEffects, QuizQuestionQuizQuestionsBridge)];
}
